export default "__VITE_ASSET__x1Nr28_R__"